








import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingErrorStore} from "@/modules/ladingerror/store";
import {LadingError} from "@/interfaces/entity/ladingerror";
@Component({
  name: "LadingErrorTableAction"
})
    export default class extends Vue{
    @Prop({required: true, type: Number})
    readonly ladingErrorId!: number;
    
    get ladingError(): LadingError {
        return LadingErrorStore.data[this.ladingErrorId];
    }
    
    set ladingError(value: LadingError){
        LadingErrorStore.data[this.ladingErrorId] = value;
    }


}
